import {Header, Pagination} from '@/components';
import type {PaginationProps} from '@/components/common/Pagination';
import {TableSkeleton} from '@/components/Table/TableSkeleton';

import BusinessFeaturesFilters from './BusinessFeaturesFilters';
import BusinessFeaturesTable from './BusinessFeaturesTable';
import useFeatureList from './useFeatureList';

const Featurelist = () => {
  const {
    isLoading,
    fetchList,
    pageInfo,
    list,
    isPageReset,
    isSearch,
    selectCurrentFilters,
    currentFilters,
    clearFilters,
  } = useFeatureList();

  return (
    <main data-cy="merchant-features-page" className="my-5 mx-4 md:mx-10">
      <Header title="Merchant Features" dataCy="merchant-features-heading" />
      <BusinessFeaturesFilters
        currentFilters={currentFilters}
        selectCurrentFilters={selectCurrentFilters}
        clearFilters={clearFilters}
      />

      <section className="pt-5 md:pt-5">
        {isLoading ? <TableSkeleton /> : <BusinessFeaturesTable items={list} />}
      </section>

      {list && list.length ? (
        <Pagination
          onPageChange={fetchList as PaginationProps['onPageChange']}
          total={pageInfo.total}
          isSearch={isSearch}
          isPageReset={isPageReset}
        />
      ) : null}
    </main>
  );
};

export default Featurelist;
